export default {
  CUSTOM_INVESTOR_GOAL_CALCULATOR_REPOSITORY: Symbol.for('CUSTOM_INVESTOR_GOAL_CALCULATOR_REPOSITORY'),
  GET_CUSTOM_INVESTOR_GOAL_CALCULATOR_QUERY: Symbol.for('GET_CUSTOM_INVESTOR_GOAL_CALCULATOR_QUERY'),
  CALCULATE_CUSTOM_GOAL_MAXIMUM_INITIAL_AMOUNT_QUERY: Symbol.for('CALCULATE_CUSTOM_GOAL_MAXIMUM_INITIAL_AMOUNT_QUERY'),
  CALCULATE_CUSTOM_GOAL_MINIMUM_ACCUMULATED_AMOUNT_QUERY: Symbol.for('CALCULATE_CUSTOM_GOAL_MINIMUM_ACCUMULATED_AMOUNT_QUERY'),
  CALCULATE_CUSTOM_GOAL_MAXIMUM_MONTHS_QUERY: Symbol.for('CALCULATE_CUSTOM_GOAL_MAXIMUM_MONTHS_QUERY'),
};
